import { CLIENT_CONTRACT } from "./client_contract"

// Shared with the native app's deferred camera orchestration.
const timing = CLIENT_CONTRACT.cameraTiming
export const CAMERA_TIMING_POLICY = Object.freeze({
  flyDurationMs: timing.flyDurationMs,
  defaultEaseDurationMs: timing.defaultEaseDurationMs,
  correctionDurationMs: timing.correctionDurationMs,
  correctionDelaysMs: timing.correctionDelaysMs,
  hardCorrectionDelaysMs: timing.hardCorrectionDelaysMs
})

export function cameraGuardMs(duration, correctionDelays, correctionDuration) {
  const lastCorrectionDelay = correctionDelays.reduce((max, delay) => Math.max(max, delay), 0)
  return Math.max(duration, lastCorrectionDelay + correctionDuration)
}
